export default __webpack_public_path__ + "images/bf39940da18b07f936070654898f5460-halloween_mobile.webp";